<template>
    <div>
        <label class="form-label">{{ title }} <sup v-if="isRequired" class="text-danger">*</sup></label>
        <the-mask
            v-model="internalValue"
            type="text"
            mask="+# ### ###-##-##"
            :masked="false"
            :class="errors && errors.length > 0 ? 'form-control is-invalid' : 'form-control'"
        />
        <div v-for="errorMess in errors" class="invalid-feedback">{{ errorMess }}</div>
    </div>
</template>

<script>
export default {
    emits: ['update:modelValue', 'change'],
    props: {
        modelValue: {
            default: null,
        },
        title: {
            type: String,
            required: true,
        },
        isRequired: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Array,
            required: false,
        },
    },
    data() {
        return {
            internalValue: this.modelValue,
        };
    },
    watch: {
        modelValue(val) {
            this.internalValue = val;
        },
        internalValue(val) {
            this.$emit('update:modelValue', val);
            this.$emit('change', val);
        },
    },
};
</script>
